var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Cart = (function (Cart) {

        Cart.Messages = (function (Messages) {

            Messages.Add = function (id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo) {

                var quantity = qty;
                if (itemInfo) {

                    var minQuantity = itemInfo.minQuantity || 0;
                    var maxQuantity = itemInfo.maxQuantity || 0;
                    var quanta = itemInfo.quanta || 0;

                    if (quanta > 0 && (qty * 100) % (quanta * 100) !== 0) {
                        quantity = Math.round(qty / quanta) * quanta;
                    }
                }

                var data = {
                    id: id,
                    skuId: skuId,
                    path: path,
                    qty: quantity,
                    extraAttributes: extraAttributes, //example: extraAttributes: [{code:'test',value:'testValue'}]
                    bundleItems: bundleItems, //example: bundleItems: [{bundleProductId:'testValue', parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
                    recipeItems: recipeItems, //example: recipeItems: [{parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
                    comboItems: comboItems, //example: comboItems: [{parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
                    itemInfo: itemInfo, //example: itemInfo: {minQuantity: 'test', maxQuantity: 'testValue'}
                    enhancedInfo: enhancedInfo
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.Add', data);
            };
            Messages.Add.className = 'Vendd.Cart.Messages.Add';

            Messages.AddCompleted = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.AddCompleted", data);
            };
            Messages.AddCompleted.className = 'Vendd.Cart.Messages.AddCompleted';

            Messages.MultipleAdd = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.MultipleAdd', data);
            };
            Messages.MultipleAdd.className = 'Vendd.Cart.Messages.MultipleAdd';

            Messages.MultipleAddSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.MultipleAddSuccess", data);
            };
            Messages.MultipleAddSuccess.className = 'Vendd.Cart.Messages.MultipleAddSuccess';

            Messages.Remove = function (id) {
                var data = {
                    id: id
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.Remove', data);
            };
            Messages.Remove.className = 'Vendd.Cart.Messages.Remove';

            Messages.MultipleRemove = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.MultipleRemove', data);
            };
            Messages.MultipleRemove.className = 'Vendd.Cart.Messages.MultipleRemove';

            Messages.MultipleRemoveSuccess = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.MultipleRemoveSuccess", response);
            };
            Messages.MultipleRemoveSuccess.className = 'Vendd.Cart.Messages.MultipleRemoveSuccess';

            Messages.SetQuantity = function (id, qty) {
                var data = {
                    id: id,
                    qty: qty
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetQuantity', data);
            };
            Messages.SetQuantity.className = 'Vendd.Cart.Messages.SetQuantity';

            Messages.SetQuantitySuccess = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.SetQuantitySuccess", response);
            };
            Messages.SetQuantitySuccess.className = 'Vendd.Cart.Messages.SetQuantitySuccess';

            Messages.SetQuantities = function (items) {
                var data = {};
                data.items = items;

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetQuantities', data);
            };
            Messages.SetQuantities.className = 'Vendd.Cart.Messages.SetQuantities';

            Messages.UpdateBundleItems = function (id, bundleItems) {

                var data = {
                    id: id,
                    bundleItems: bundleItems //example: bundleItems: [{bundleProductId:'testValue', parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.UpdateBundleItems', data);
            };
            Messages.UpdateBundleItems.className = 'Vendd.Cart.Messages.UpdateBundleItems';

            Messages.Clear = function () {
                var data = {};

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.Clear', data);
            };
            Messages.Clear.className = 'Vendd.Cart.Messages.Clear';

            Messages.ClearSuccess = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ClearSuccess', data);
            };
            Messages.ClearSuccess.className = 'Vendd.Cart.Messages.ClearSuccess';

            Messages.UpdateCartProductReplacingTypes = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.UpdateCartProductReplacingTypes', data);
            };
            Messages.UpdateCartProductReplacingTypes.className = 'Vendd.Cart.Messages.UpdateCartProductReplacingTypes';

            Messages.UpdateCartProductReplacingTypesSuccess = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.UpdateCartProductReplacingTypesSuccess', data);
            };
            Messages.UpdateCartProductReplacingTypesSuccess.className = 'Vendd.Cart.Messages.UpdateCartProductReplacingTypesSuccess';

            Messages.UpdateCartProductReplacingTypesFailed = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.UpdateCartProductReplacingTypesFailed', data);
            };
            Messages.UpdateCartProductReplacingTypesFailed.className = 'Vendd.Cart.Messages.UpdateCartProductReplacingTypesFailed';

            Messages.ApplyCoupon = function (code) {
                var data = {
                    code: code
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ApplyCoupon', data);
            };
            Messages.ApplyCoupon.className = 'Vendd.Cart.Messages.ApplyCoupon';

            Messages.ApplyCouponSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Contact.Messages.ApplyCouponSuccess', response);
            };
            Messages.ApplyCouponSuccess.className = 'Vendd.Contact.Messages.ApplyCouponSuccess';

            Messages.ClearCoupon = function (code) {
                var data = {
                    code: code
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ClearCoupon', data);
            };
            Messages.ClearCoupon.className = 'Vendd.Cart.Messages.ClearCoupon';

            Messages.ClearCoupons = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ClearCoupons');
            };
            Messages.ClearCoupons.className = 'Vendd.Cart.Messages.ClearCoupons';

            Messages.ApplyExternalCoupon = function (code) {
                var data = {
                    code: code
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ApplyExternalCoupon', data);
            };
            Messages.ApplyExternalCoupon.className = 'Vendd.Cart.Messages.ApplyExternalCoupon';

            Messages.ClearExternalCoupon = function (code) {
                var data = {
                    code: code
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ClearExternalCoupon', data);
            };
            Messages.ClearExternalCoupon.className = 'Vendd.Cart.Messages.ClearExternalCoupon';

            Messages.ClearExternalCoupons = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ClearExternalCoupons');
            };
            Messages.ClearExternalCoupons.className = 'Vendd.Cart.Messages.ClearExternalCoupons';

            Messages.GetModel = function (options) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.GetModel', options);
            };
            Messages.GetModel.className = 'Vendd.Cart.Messages.GetModel';

            Messages.Changed = function (model) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.Changed', model);
            };
            Messages.Changed.className = 'Vendd.Cart.Messages.Changed';

            Messages.Failed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.Failed', response);
            };
            Messages.Failed.className = 'Vendd.Cart.Messages.Failed';

            Messages.Warning = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.Warning', response);
            };
            Messages.Warning.className = 'Vendd.Cart.Messages.Warning';

            Messages.ApplyShippingData = function (countryCode, postCode, areaId, shippingMethodId, shippingCompanyId) {
                var data = {
                    countryCode: countryCode,
                    postCode: postCode,
                    areaId: areaId,
                    shippingMethodId: shippingMethodId,
                    shippingCompanyId: shippingCompanyId
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ApplyShippingData', data);
            };
            Messages.ApplyShippingData.className = 'Vendd.Cart.Messages.ApplyShippingData';

            Messages.ApplyShippingDataSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.ApplyShippingDataSuccess", data);
            };
            Messages.ApplyShippingDataSuccess.className = 'Vendd.Cart.Messages.ApplyShippingDataSuccess';

            Messages.ApplyShippingDataFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.ApplyShippingDataFailed", response);
            };
            Messages.ApplyShippingDataFailed.className = "Vendd.Cart.Messages.ApplyShippingDataFailed";

            Messages.GetShippingModel = function (countryCode, postCode, areaId, shippingMethodId, shippingCompanyId) {
                var data = {
                    countryCode: countryCode,
                    postCode: postCode,
                    areaId: areaId,
                    shippingMethodId: shippingMethodId,
                    shippingCompanyId: shippingCompanyId
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.GetShippingModel', data);
            };
            Messages.GetShippingModel.className = 'Vendd.Cart.Messages.GetShippingModel';

            Messages.GetShippingModelSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.GetShippingModelSuccess", data);
            };
            Messages.GetShippingModelSuccess.className = 'Vendd.Cart.Messages.GetShippingModelSuccess';

            Messages.GetShippingModelFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.GetShippingModelFailed", response);
            };
            Messages.GetShippingModelFailed.className = "Vendd.Cart.Messages.GetShippingModelFailed";

            Messages.SetGiftwrap = function (id, wrapId, message) {
                var data = {
                    id: id,
                    wrapId: wrapId,
                    message: message
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetGiftwrap', data);
            };
            Messages.SetGiftwrap.className = 'Vendd.Cart.Messages.SetGiftwrap';

            Messages.SetGiftwraps = function (items) {
                var data = {};
                data.items = items;

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetGiftwraps', data);
            };
            Messages.SetGiftwraps.className = 'Vendd.Cart.Messages.SetGiftwraps';

            Messages.ApplyExtraAllowanceOrCharge = function (itemId, shopAllowanceorChargeId) {
                var data = {
                    itemId: itemId,
                    shopAllowanceorChargeId: shopAllowanceorChargeId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ApplyExtraAllowanceOrCharge', data);
            };
            Messages.ApplyExtraAllowanceOrCharge.className = 'Vendd.Cart.Messages.ApplyExtraAllowanceOrCharge';

            Messages.DisableExtraAllowanceOrCharge = function (itemId, shopAllowanceorChargeId) {
                var data = {
                    itemId: itemId,
                    shopAllowanceorChargeId: shopAllowanceorChargeId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.DisableExtraAllowanceOrCharge', data);
            };
            Messages.DisableExtraAllowanceOrCharge.className = 'Vendd.Cart.Messages.DisableExtraAllowanceOrCharge';

            Messages.AddOrderItemsToCart = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.AddOrderItemsToCart', data);
            };
            Messages.AddOrderItemsToCart.className = 'Vendd.Cart.Messages.AddOrderItemsToCart';

            Messages.SetGiftCard = function (code, amount) {
                var data = {
                    code: code,
                    amount: amount,
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetGiftCard', data);
            };
            Messages.SetGiftCard.className = 'Vendd.Cart.Messages.SetGiftCard';

            Messages.GiftCardApplySuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Contact.Messages.GiftCardApplySuccess', response);
            };
            Messages.GiftCardApplySuccess.className = 'Vendd.Contact.Messages.GiftCardApplySuccess';

            Messages.GiftCardApplyFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.GiftCardApplyFailed', response);
            };
            Messages.GiftCardApplyFailed.className = 'Vendd.Cart.Messages.GiftCardApplyFailed';

            Messages.AddGiftCartEmailAddress = function (itemsList) {
                var data = {
                    items: itemsList
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.AddGiftCartEmailAddress', data);
            };
            Messages.AddGiftCartEmailAddress.className = 'Vendd.Cart.Messages.AddGiftCartEmailAddress';

            Messages.AddGiftCartEmailAddressSuccess = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.AddGiftCartEmailAddressSuccess');
            };
            Messages.AddGiftCartEmailAddressSuccess.className = 'Vendd.Cart.Messages.AddGiftCartEmailAddressSuccess';

            Messages.ClearAllGiftCards = function (items) {
                var data = {};

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ClearAllGiftCards', data);
            };
            Messages.ClearAllGiftCards.className = 'Vendd.Cart.Messages.ClearAllGiftCards';

            Messages.ClearGiftCard = function (code) {
                var data = {};
                data.code = code;

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ClearGiftCard', data);
            };

            Messages.ClearGiftCard.className = 'Vendd.Cart.Messages.ClearGiftCard';

            Messages.AddOrderItemsToCartSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.AddOrderItemsToCartSuccess", data);
            };
            Messages.AddOrderItemsToCartSuccess.className = 'Vendd.Cart.Messages.AddOrderItemsToCartSuccess';

            Messages.AddOrderItemsToCartFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.AddOrderItemsToCartFailed", response);
            };
            Messages.AddOrderItemsToCartFailed.className = "Vendd.Cart.Messages.AddOrderItemsToCartFailed";

            Messages.AddMultipleSkusToCart = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.AddMultipleSkusToCart', data);
            };
            Messages.AddMultipleSkusToCart.className = 'Vendd.Cart.Messages.AddMultipleSkusToCart';
            Messages.AddMultipleSkusToCartSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.AddMultipleSkusToCartSuccess", data);
            };
            Messages.AddMultipleSkusToCartSuccess.className = 'Vendd.Cart.Messages.AddMultipleSkusToCartSuccess';

            Messages.AddMultipleSkusToCartFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.AddMultipleSkusToCartFailed", response);
            };
            Messages.AddMultipleSkusToCartFailed.className = "Vendd.Cart.Messages.AddMultipleSkusToCartFailed";


            Messages.ShowMessages = function (response) {

                var messages = [], code = "";

                if (response.data) {
                    var responseData = response.data || {};
                    messages = responseData.Messages || [];
                }

                if (response.Messages) {
                    messages = response.Messages || [];
                }

                if (response.code) {
                    code = response.code;
                }

                var data = {
                    resultCode: code,
                    resultMessages: messages
                };

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.ShowMessages", data);
            }
            Messages.ShowMessages.className = "Vendd.Cart.Messages.ShowMessages";

            Messages.DownLoadExcel = function (response) {

                var messages = [];

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.DownLoadExcel", response);
            }
            Messages.DownLoadExcel.className = "Vendd.Cart.Messages.DownLoadExcel";

            Messages.DownLoadExcelSuccess = function (response) {

                var messages = [];

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.DownLoadExcelSuccess", response);
            }
            Messages.DownLoadExcelSuccess.className = "Vendd.Cart.Messages.DownLoadExcelSuccess";

            Messages.DownLoadExcelFailure = function (response) {

                var messages = [];

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.DownLoadExcelFailure", response);
            }
            Messages.DownLoadExcelFailure.className = "Vendd.Cart.Messages.DownLoadExcelFailure";

            Messages.ProductAdded = function (id, skuId, responseData) {
                var data = {};
                data.id = id;
                data.skuId = skuId;
                data.responseData = JSON.parse(responseData);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ProductAdded', data);
            };
            Messages.ProductAdded.className = 'Vendd.Cart.Messages.ProductAdded';

            Messages.ProductRemoved = function (cartId, productId, skuId) {
                var data = {};
                data.cartId = cartId;
                data.productId = productId;
                data.skuId = skuId;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.ProductRemoved', data);
            };
            Messages.ProductRemoved.className = 'Vendd.Cart.Messages.ProductRemoved';

            Messages.AlreadyInCart = function (id) {
                var data = {};
                data.id = id;

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.AlreadyInCart', data);
            };
            Messages.AlreadyInCart.className = 'Vendd.Cart.Messages.AlreadyInCart';

            Messages.CollectionAdded = function () {
                var data = {};
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.CollectionAdded', data);
            };
            Messages.CollectionAdded.className = 'Vendd.Cart.Messages.CollectionAdded';

            Messages.SetDeliveryPoint = function (deliveryPointId) {
                var data = {
                    deliveryPointId: deliveryPointId
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetDeliveryPoint', data);
            };
            Messages.SetDeliveryPoint.className = 'Vendd.Cart.Messages.SetDeliveryPoint';

            Messages.SetDigitalCare = function (IsDigitalCareSelected) {
                var data = {
                    IsDigitalCareSelected: IsDigitalCareSelected
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetDigitalCare', data);
            };
            Messages.SetDigitalCare.className = 'Vendd.Cart.Messages.SetDigitalCare';

            Messages.SetDigitalCareSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Contact.Messages.SetDigitalCareSuccess', response);
            };
            Messages.SetDigitalCareSuccess.className = 'Vendd.Contact.Messages.SetDigitalCareSuccess';

            Messages.SetDigitalCareFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.SetDigitalCareFailure', response);
            };
            Messages.SetDigitalCareFailure.className = 'Vendd.Cart.Messages.SetDigitalCareFailure';

            Messages.GetPromotedDiscounts = function () {
                var data = { };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.GetPromotedDiscounts', data);
            };
            Messages.GetPromotedDiscounts.className = 'Vendd.Cart.Messages.GetPromotedDiscounts';

            Messages.GetPromotedDiscountsSuccess = function (model) {
                var data = model.data;
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.GetPromotedDiscountsSuccess", data);
            };
            Messages.GetPromotedDiscountsSuccess.className = 'Vendd.Cart.Messages.GetPromotedDiscountsSuccess';

            Messages.GetPromotedDiscountsFailure = function (model) {
                var data = model.data;
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Cart.Messages.GetPromotedDiscountsFailure", data);
            };
            Messages.GetPromotedDiscountsFailure.className = 'Vendd.Cart.Messages.GetPromotedDiscountsFailure';

            Messages.CheckSameDayDeliveryAvailability = function (items, useCartItems, postalCode, countryCode) {
                var data = {
                    request: {
                        items: items,
                        useCartItems: useCartItems,
                        postalCode: postalCode,
                        countryCode: countryCode
                    }
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.CheckSameDayDeliveryAvailability', data);
            };
            Messages.CheckSameDayDeliveryAvailability.className = 'Vendd.Cart.Messages.CheckSameDayDeliveryAvailability';

            Messages.CheckSameDayDeliveryAvailabilitySuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Contact.Messages.CheckSameDayDeliveryAvailabilitySuccess', response);
            };
            Messages.CheckSameDayDeliveryAvailabilitySuccess.className = 'Vendd.Contact.Messages.CheckSameDayDeliveryAvailabilitySuccess';

            Messages.CheckSameDayDeliveryAvailabilityFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Cart.Messages.CheckSameDayDeliveryAvailabilityFailure', response);
            };
            Messages.CheckSameDayDeliveryAvailabilityFailure.className = 'Vendd.Cart.Messages.CheckSameDayDeliveryAvailabilityFailure';

            return Messages;

        })(Cart.Messages || {});

        return Cart;

    })(Vendd.Cart || {});

    return Vendd;

})(Vendd || {});
